'use client'

// Next Imports
import { redirect, usePathname } from 'next/navigation'

// Config Imports
import { i18n } from '@configs/i18n'

// Função para detectar idioma do navegador (client-side fallback)
function getBrowserLanguage(): string {
  if (typeof window !== 'undefined') {
    // Verificar se há preferência salva em cookie
    const cookies = document.cookie.split(';')

    const languageCookie = cookies.find(cookie =>
      cookie.trim().startsWith('preferred-language=')
    )

    if (languageCookie) {
      const savedLanguage = languageCookie.split('=')[1]

      if (i18n.locales.includes(savedLanguage as any)) {
        return savedLanguage
      }
    }

    // Tentar idioma do navegador
    const browserLang = navigator.language || 'pt'
    const langCode = browserLang.split('-')[0]

    if (i18n.locales.includes(langCode as any)) {
      return langCode
    }
  }

  return i18n.defaultLocale
}

const LangRedirect = () => {
  const pathname = usePathname()

  // Detectar idioma preferido
  const detectedLocale = getBrowserLanguage()

  const redirectUrl = `/${detectedLocale}${pathname}`

  redirect(redirectUrl)
}

export default LangRedirect
